export enum QueryKey {
  Authentication = "Authentication",
  Service = "Service",
  Tenant = "Tenant",
  Person = "Person",
  Role = "Role",
  GoogleCloudStorage = "GoogleCloudStorage",
  Member = "Member",
  Children = "Children",
  Parent = "Parent",
  TransactionService = "TransactionService",
  TransactionAddon = "TransactionAddon",
  Transaction = "Transaction",
  Item = "Item",
Waiver = "Waiver",
TransactionWaiver = "TransactionWaiver",
Subscription = "Subscription",
// KEY ADD
}
